import { HttpStatus, type HttpStatusCode, type UpperSnakeCase } from '../../lib/entry.js';
import { type ErrorCode, PoolbettingError } from './PoolbettingError.js';

/**
 * Error instance representing when a validation has failed.
 * This is likely to happen when validating user input and should synonym to "client error" as HTTP 4XX
 */
export class BadRequestError<TCode extends string = ErrorCode> extends PoolbettingError<TCode | 'CLIENT'> {
  protected override httpStatus: HttpStatusCode = HttpStatus.BadRequest;

  constructor(
    message = 'Validation error',
    options?: ErrorOptions,
    code: (TCode & UpperSnakeCase<TCode>) | 'CLIENT' = 'CLIENT'
  ) {
    super(message, options, code);
    this.name = 'BadRequestError';
  }
}
